import img1 from '@/assets/images/1.jpg'
import img2 from '@/assets/images/2.jpg'
import img3 from '@/assets/images/3.jpg'
import img4 from '@/assets/images/4.jpg'
import circleSketch from '@/assets/sketches/circle'
import headSketch from '@/assets/sketches/head'
import typeSketch from '@/assets/sketches/type'
import maskSketch from '@/assets/sketches/mask'
import i18n from '@/i18n'

export default [
  {
    id: '1',
    slug: i18n.t('wish_1_title').toLowerCase().replace(/<br \/>/g, '').replace(/\s/g, '-').replace(/[-]+/g, '-').replace(/[àâ]/g, 'a').replace(/[éèê]/g, 'e'),
    title: i18n.t('wish_1_title'),
    position: { x: 1, y: 31 },
    stackedPosition: { x: 11, y: 9 },
    size: { width: 26, height: 17 },
    quote: { text: i18n.t('wish_1_quote'), author: i18n.t('wish_1_author') },
    sketch: circleSketch,
    cover: img3,
    background: 'accent',
    titleColor: '#000000'
  },
  {
    id: '2',
    slug: i18n.t('wish_2_title').toLowerCase().replace(/<br \/>/g, '').replace(/\s/g, '-').replace(/[-]+/g, '-').replace(/[àâ]/g, 'a').replace(/[éèê]/g, 'e'),
    title: i18n.t('wish_2_title'),
    position: { x: -29, y: 1 },
    stackedPosition: { x: -11, y: 3 },
    size: { width: 26, height: 17 },
    quote: { text: i18n.t('wish_2_quote'), author: i18n.t('wish_2_author') },
    sketch: headSketch,
    cover: img1,
    background: 'accent',
    titleColor: '#000000'
  },
  {
    id: '3',
    slug: i18n.t('wish_3_title').toLowerCase().replace(/<br \/>/g, '').replace(/\s/g, '-').replace(/[-]+/g, '-').replace(/[àâ]/g, 'a').replace(/[éèê]/g, 'e'),
    title: i18n.t('wish_3_title'),
    position: { x: 30, y: -6 },
    stackedPosition: { x: 10, y: -8 },
    size: { width: 26, height: 17 },
    quote: { text: i18n.t('wish_3_quote'), author: i18n.t('wish_3_author') },
    sketch: typeSketch,
    cover: img4,
    background: 'dark',
    titleColor: '#ffffff'
  },
  {
    id: '4',
    slug: i18n.t('wish_4_title').toLowerCase().replace(/<br \/>/g, '').replace(/\s/g, '-').replace(/[-]+/g, '-').replace(/[àâ]/g, 'a').replace(/[éèê]/g, 'e'),
    title: i18n.t('wish_4_title'),
    position: { x: 4, y: -32 },
    stackedPosition: { x: -14, y: -20 },
    size: { width: 26, height: 17 },
    quote: { text: i18n.t('wish_4_quote'), author: i18n.t('wish_4_author') },
    sketch: maskSketch,
    cover: img2,
    background: 'dark',
    titleColor: '#ffffff'
  }
]
